import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { spacing } from 'ui/theme';
import { Button } from '@iterable/deprecated_react_components';

export const StyledCoreButton = styled(Button)<{ $showBorders: boolean }>`
  &&&&&&& {
    height: 100%;
    margin: 0;
    padding: ${pxToRem(4)} ${pxToRem(10)};
    border: ${({ $showBorders }) => ($showBorders ? `${pxToRem(1)} solid #d6d6d6` : 'inherit')};
    box-shadow: ${({ $showBorders }) =>
      $showBorders ? `inset 0 ${pxToRem(1)} 0 rgba(255, 255, 255, 0.8)` : 'inherit'};
  }
`;

export const ActionButtonContainer = styled.div<{
  isGroupActionButtons: boolean;
}>`
  display: inline-flex;
  align-items: center;
  margin: 0;
  ${({ isGroupActionButtons }) =>
    isGroupActionButtons
      ? ` gap: ${spacing.quarter}; `
      : `
        border-top-right-radius: ${pxToRem(3)};
        border-bottom-right-radius: ${pxToRem(3)};
        display: flex;
        background: #eff0f0;
  `}
`;
